module.exports = __webpack_public_path__ + "static/media/Shrine6.5555b5c7.jpg";